import { useParams } from 'react-router';

export default (): [boolean, string | undefined] => {
    const { id } = useParams<{ id?: string }>();
    const isEdit = !!id && id !== 'new';

    return [isEdit, id];
};
